import Swal from "sweetalert2";
export default {
  methods: {
    $messageInfo(text) {
      this.$notify({
        timeout: 3000,
        type: "info",
        message: text,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top"
      });
    },
    $messageSuccess(text) {
      this.$notify({
        timeout: 3000,
        type: "success",
        message: text,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top"
      });
    },
    $messageError(text) {
      this.$notify({
        timeout: 3000,
        type: "danger",
        message: text,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top"
      });
    },
    $confirm(text, title) {
      Swal.fire({
        title: title,
        text: text,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          return true;
        }
      });
    },
    /**
     * @param {tHeader}: array header corresponding each column in row
     * @param {filterVal} : array key in one object representation in array
     * @param {list}: list to exported
     */
    $exportExcel(tHeader, filterVal, list) {
      import("@/vendor/export-excel")
        .then(excel => {
          const data = this.$formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "Danh sách",
            autoWidth: true,
            bookType: "xlsx"
          });
        })
        .catch(err => console.log(err));
    },
    $formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },
    formatDate(timeFormated) {
      let hours = timeFormated.getHours();
      let minutes = timeFormated.getMinutes();
      let seconds = timeFormated.getSeconds();

      let time =
        hours.toString().padStart(2, 0) +
        ":" +
        minutes.toString().padStart(2, 0) +
        ":" +
        seconds.toString().padStart(2, 0);
      let date =
        timeFormated
          .getDate()
          .toString()
          .padStart(2, 0) +
        "/" +
        (timeFormated.getMonth() + 1).toString().padStart(2, 0) +
        "/" +
        timeFormated.getFullYear().toString();
      return date + " " + time;
    },
    formatMoney(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    },
    formatNumber(n) {
      // format number 1000000 to 1,234,567
      return n.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  }
};
